import type React from 'react';
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { RecommendModal } from '@pages/shop/recommend-modal';
import { Search } from '@features/common';
import { FilterIcon, Search as SearchIcon, ShareProductNew } from '@shared/assets';
import { useUser, useWindowWidth } from '@shared/hooks';
import { IconButton } from '@shared/ui';
import { useProduct, useProducts, useSearch } from '@src/library/hooks/shop';
import styles from './styles.module.scss';

export const NavRight: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  const product = useProduct();

  const { pathname } = useLocation();

  const windowWidth = useWindowWidth();

  const search = useSearch();

  const { isAuth } = useUser();
  const recommend = `/shop/store/products/product/${product.productId}`;

  const titles = useProducts().products.map((product) => product.title);

  return (
    <>
      {isAuth && pathname.endsWith(`product/${product.productId.toString()}`) && (
        <Tooltip title="Рекомендовать" disableInteractive>
          <IconButton variant="dark" onClick={() => setShowModal(true)}>
            <ShareProductNew />
          </IconButton>
        </Tooltip>
      )}

      {showModal && (
        <RecommendModal
          toggleModal={setShowModal}
          recommend={recommend}
          productTitle={product.info.title}
        />
      )}

      {pathname.endsWith('search') && (
        <Search mobile search={search.value} onSearch={search.setValue} titles={titles} />
      )}

      {(pathname.endsWith('products') || pathname.endsWith('products/')) && (
        <>
          {windowWidth > 480 && (
            <Search search={search.value} onSearch={search.setValue} titles={titles} />
          )}
          {windowWidth <= 480 && (
            <NavLink
              to={`${pathname.endsWith('/') ? pathname + 'search' : pathname + '/search'}`}
              className={styles.searchMobileIcon}
            >
              <IconButton variant="mobile">
                <SearchIcon />
              </IconButton>
            </NavLink>
          )}
          <IconButton variant="mobile">
            <FilterIcon />
          </IconButton>
        </>
      )}
    </>
  );
};
